// Shared presentation for list, assignment, picker and enrollment tables.
export const tablePaperSx = {
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    border: "1px solid",
    borderColor: "divider",
    borderRadius: 1.2,
    boxShadow: "none",
    bgcolor: "background.paper",
    "& .MuiTableCell-root": { fontSize: 14, lineHeight: 1.5, borderColor: "divider", py: 1, px: 1.5 },
    "& .MuiTableCell-head": { bgcolor: "background.default", color: "text.secondary", fontWeight: 600, height: 42 },
    "& .MuiTableCell-paddingCheckbox": { width: 44, px: 0.5 },
    "& .MuiTableBody-root .MuiTableRow-root": {
        bgcolor: "background.paper",
        "&:hover": { bgcolor: "action.hover" },
        "&.Mui-selected": { bgcolor: "action.selected" },
    },
    "& .MuiTableBody-root .MuiTypography-body1, & .MuiTableBody-root .MuiTypography-body2": { fontSize: 14 },
    "& .MuiCheckbox-root": { padding: "6px" },
    "& .MuiTablePagination-root": { borderTop: "1px solid", borderColor: "divider" },
    "& .MuiTablePagination-toolbar": { minHeight: 48, px: 1.5, flexWrap: "wrap" },
    "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": { fontSize: 14 },
};

export const tableToolbarSx = {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 1,
    p: 1.5,
    borderBottom: "1px solid",
    borderColor: "divider",
};
